/**
 * GiftTiers — SOLO UI de líneas en carrito.
 *
 * El Cart Transform a veces duplica el %:
 *   original_line = list × (1−%)  ← correcto (un solo %)
 *   final_line    = original × (1−%) ← incorrecto (segundo %)
 *
 * Este script SOLO repinta el precio de cada línea GiftTiers:
 *   - Con qty ≥ buyQuantity: muestra original_line (un solo %)
 *   - Con qty < buyQuantity: muestra catálogo (0 %)
 *   - Badge
 *
 * NO modifica WSAIO.fetchCart, el botón Pagar, checkout ni redirects.
 * El botón Pagar de WSAIO ya usa checkout_price_from_original_total_price
 * (el total bueno). Tocar fetchCart/botón empeoraba el cobro.
 */
(function () {
  "use strict";

  var CONFIG_ID = "gifttiers-qty-discount-config";
  var BADGE_CLASS = "gifttiers-qty-badge";
  var ROOT_ATTR = "data-gifttiers-qty-line";
  var timer = null;

  function normalizeId(id) {
    if (id == null) return "";
    var s = String(id);
    var m = s.match(/\/(\d+)$/);
    return m ? m[1] : s.trim();
  }

  function parseInlineConfig() {
    var el = document.getElementById(CONFIG_ID);
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent || "{}");
      if (!data || !Array.isArray(data.offers) || !data.offers.length) return null;
      if (data.settings && data.settings.isActive === false) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function fetchProxyConfig() {
    var meta = window.GiftTiersQtyDiscount || {};
    var base = meta.proxyUrl || "/apps/gifttiers/quantity-discount-config";
    var shop = meta.shop || (window.Shopify && window.Shopify.shop) || "";
    var url = base;
    if (shop && url.indexOf("shop=") === -1) {
      url += (url.indexOf("?") === -1 ? "?" : "&") + "shop=" + encodeURIComponent(shop);
    }
    return fetch(url, { credentials: "same-origin", cache: "no-store" })
      .then(function (r) {
        if (!r.ok) throw new Error("qty config " + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || data.settings?.isActive === false) return null;
        if (!Array.isArray(data.offers) || !data.offers.length) return null;
        var el = document.getElementById(CONFIG_ID);
        if (el) el.textContent = JSON.stringify(data);
        return data;
      })
      .catch(function () {
        return null;
      });
  }

  function loadConfig() {
    var inline = parseInlineConfig();
    if (inline) return Promise.resolve(inline);
    return fetchProxyConfig();
  }

  function formatMoney(cents) {
    var amount = Number(cents) || 0;
    var format =
      (window.GiftTiersQtyDiscount && window.GiftTiersQtyDiscount.moneyFormat) ||
      "{{amount}} €";
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(amount, format);
    }
    var value = (amount / 100).toFixed(2).replace(".", ",");
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(amount / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  function discountedUnits(mode, buyQty, lineQty) {
    var n = Math.max(1, buyQty | 0);
    var q = Math.max(0, lineQty | 0);
    if (q <= 0) return 0;
    if (String(mode).toUpperCase() === "FIXED") return q >= n ? n : 0;
    return Math.floor(q / n) * n;
  }

  function selectOffer(offers, variantId) {
    var vid = normalizeId(variantId);
    var matches = (offers || []).filter(function (o) {
      if (!o || !(Number(o.discountValue) > 0) || !(Number(o.buyQuantity) >= 1)) return false;
      return (o.variantIds || []).some(function (id) {
        return normalizeId(id) === vid;
      });
    });
    if (!matches.length) return null;
    matches.sort(function (a, b) {
      return (Number(b.priority) || 0) - (Number(a.priority) || 0);
    });
    return matches[0];
  }

  function giftText(key, fallback) {
    var texts = window.GiftTiersQtyDiscount && window.GiftTiersQtyDiscount.texts;
    return (texts && texts[key]) || fallback;
  }

  function offerMessage(offer) {
    if (offer.message && String(offer.message).trim()) return String(offer.message).trim();
    return offer.buyQuantity + "x -" + offer.discountValue + "%";
  }

  function isGiftItem(item) {
    var props = item.properties || {};
    var flag = props._is_gift || props.is_gift;
    if (flag === true || flag === "true" || flag === "1" || flag === 1) return true;
    return !!(props._gift_tier_id || props.gift_tier_id);
  }

  function isGiftTiersCartDiscount(item) {
    var discs = item.discounts || [];
    for (var i = 0; i < discs.length; i++) {
      var t = String((discs[i] && discs[i].title) || "");
      if (/COMPRANDO|UNIDADES|BUY\s*\d|quantity\s*discount/i.test(t)) return true;
    }
    return false;
  }

  function giftTiersDiscountPct(item, offer) {
    if (offer && Number(offer.discountValue) > 0) return Number(offer.discountValue);
    var discs = item.discounts || [];
    for (var i = 0; i < discs.length; i++) {
      var d = discs[i];
      var t = String((d && d.title) || "");
      if (!/COMPRANDO|UNIDADES|BUY\s*\d|quantity\s*discount/i.test(t)) continue;
      var m = t.match(/(\d+)\s*%/);
      if (m) return Number(m[1]);
    }
    return 15;
  }

  function findLineRoots(variantId, key) {
    var nodes = document.querySelectorAll("[" + ROOT_ATTR + "]");
    var out = [];
    var vid = normalizeId(variantId);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var elVid = normalizeId(el.getAttribute("data-variant-id"));
      var elKey = el.getAttribute("data-line-key") || "";
      if (key && elKey && elKey === key) {
        out.push(el);
        continue;
      }
      if (elVid && elVid === vid) out.push(el);
    }
    return out;
  }

  function setBadge(root, text, active) {
    if (!root) return;
    var badge = root.querySelector("." + BADGE_CLASS);
    if (!badge) {
      badge = document.createElement("div");
      badge.className = BADGE_CLASS;
      var info = root.querySelector(".product-cart-item-info, .product-name > div, td.product-name");
      (info || root).appendChild(badge);
    }
    if (!text) {
      badge.hidden = true;
      badge.textContent = "";
      return;
    }
    badge.hidden = false;
    badge.textContent = text;
    badge.classList.toggle("is-active", !!active);
    badge.classList.toggle("is-hint", !active);
  }

  function updatePriceDom(root, catalogCents, finalCents) {
    if (!root) return;
    var priceHosts = root.querySelectorAll(".price");
    if (!priceHosts.length) return;
    var showCut = catalogCents > finalCents + 1;
    var html = showCut
      ? "<del><span class=\"amount\">" +
        formatMoney(catalogCents) +
        "</span></del> <ins><span class=\"amount\">" +
        formatMoney(finalCents) +
        "</span></ins>"
      : "<ins><span class=\"amount\">" + formatMoney(finalCents) + "</span></ins>";

    for (var i = 0; i < priceHosts.length; i++) {
      var host = priceHosts[i];
      var unit = host.querySelector("small.unit-price");
      var nextHtml = html + (unit ? " " + unit.outerHTML : "");
      host.innerHTML = nextHtml;
      host.setAttribute("data-gifttiers-price-locked", "1");
      host.setAttribute("data-gifttiers-price-html", nextHtml);
      var ins = host.querySelector("ins");
      if (ins) {
        var color = showCut ? "#aa1936" : "#151515";
        ins.style.setProperty("color", color, "important");
        var amt = ins.querySelector(".amount");
        if (amt) amt.style.setProperty("color", color, "important");
      }
      var del = host.querySelector("del");
      if (del && !showCut) del.style.setProperty("display", "none", "important");
    }
  }

  function looksDoubleDiscounted(item, pct) {
    if (!isGiftTiersCartDiscount(item) || !(pct > 0)) return false;
    var price = Number(item.price) || 0;
    var qty = Math.max(1, Number(item.quantity) || 1);
    var original = Number(item.original_line_price) || 0;
    var final = Number(item.final_line_price) || 0;
    var factor = (100 - pct) / 100;
    if (!(factor > 0) || !(price > 0) || !(original > 0) || !(final > 0)) return false;
    if (Math.abs(original - price * qty) > qty) return false;
    if (Math.abs(final - Math.round(original * factor)) > qty) return false;
    var inferred = Math.round(price / factor);
    if (Math.abs(Math.round(inferred * factor) - price) > 1) return false;
    return inferred > price && final < original - 1;
  }

  function lineQualifies(item, offer) {
    var qty = Number(item && item.quantity) || 0;
    if (qty < 1) return false;
    if (offer) return discountedUnits(offer.mode, offer.buyQuantity, qty) > 0;
    if (isGiftTiersCartDiscount(item)) return qty >= 2;
    return false;
  }

  function catalogUnit(roots, item, pct, doubleDip) {
    var fromDom = 0;
    (roots || []).forEach(function (root) {
      var n = Number(root.getAttribute("data-catalog-unit"));
      if (!Number.isNaN(n) && n > 0) fromDom = n;
    });
    if (fromDom > 0) return fromDom;
    var price = Number(item.price) || 0;
    if (doubleDip && pct > 0) {
      var inferred = Math.round(price / ((100 - pct) / 100));
      if (inferred > price) return inferred;
    }
    return price;
  }

  function displayFinalLine(item, offer, catalogLine, pct) {
    if (offer && !lineQualifies(item, offer)) return catalogLine;
    if (looksDoubleDiscounted(item, pct)) {
      return Number(item.original_line_price) || catalogLine;
    }
    return Number(item.final_line_price != null ? item.final_line_price : item.line_price) || catalogLine;
  }

  function applyFromCart(cart, config) {
    if (!cart || !cart.items) return;
    var offers = (config && config.offers) || [];

    cart.items.forEach(function (item) {
      if (isGiftItem(item)) return;
      var roots = findLineRoots(item.variant_id, item.key);
      if (!roots.length) return;

      var offer = selectOffer(offers, item.variant_id);
      if (!(offer || isGiftTiersCartDiscount(item))) return;

      var qty = Number(item.quantity) || 0;
      var pct = giftTiersDiscountPct(item, offer);
      var doubleDip = looksDoubleDiscounted(item, pct);
      var unit = catalogUnit(roots, item, pct, doubleDip);
      var catalogLine = Math.round(unit * Math.max(1, qty));
      var finalLine = displayFinalLine(item, offer, catalogLine, pct);
      var qualifies = lineQualifies(item, offer);
      var hasCut = catalogLine > finalLine + 1;

      roots.forEach(function (root) {
        root.setAttribute("data-line-key", item.key || "");
        root.setAttribute("data-qty", String(qty));
        root.setAttribute("data-catalog-unit", String(unit));
        root.setAttribute("data-final-line", String(finalLine));
        updatePriceDom(root, catalogLine, finalLine);

        if (qualifies && hasCut) {
          setBadge(
            root,
            offer ? offerMessage(offer) : (item.discounts[0] && item.discounts[0].title) || "",
            true
          );
        } else if (offer && qty > 0 && qty < Number(offer.buyQuantity || 2)) {
          var left = Number(offer.buyQuantity || 2) - qty;
          setBadge(
            root,
            left === 1
              ? giftText("addOne", "Añade 1 más →") + " " + offerMessage(offer)
              : giftText("addMore", "Añade __N__ más →").replace("__N__", left) + " " + offerMessage(offer),
            false
          );
        } else {
          setBadge(root, "", false);
        }
      });
    });
  }

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" }).then(function (r) {
      if (!r.ok) throw new Error("cart.js " + r.status);
      return r.json();
    });
  }

  function refresh() {
    loadConfig()
      .then(function (config) {
        if (!config) return;
        return fetchCart().then(function (cart) {
          applyFromCart(cart, config);
        });
      })
      .catch(function () {});
  }

  function scheduleRefresh(delay) {
    clearTimeout(timer);
    timer = setTimeout(refresh, typeof delay === "number" ? delay : 180);
  }

  function boot() {
    scheduleRefresh(80);
    scheduleRefresh(400);

    [
      "cart-drawer:open",
      "cart:refresh",
      "cart:item-added",
      "line-item:change:end",
      "cart:updated",
    ].forEach(function (evt) {
      document.addEventListener(evt, function () {
        scheduleRefresh(250);
      });
    });

    if (window.WSAIO && typeof window.WSAIO.cartDrawer === "function" && !window.WSAIO.__gifttiersUiWrapped) {
      var original = window.WSAIO.cartDrawer.bind(window.WSAIO);
      window.WSAIO.cartDrawer = function () {
        var result = original.apply(window.WSAIO, arguments);
        // Mientras cart-settle está activo, WSAIO.cartDrawer lo provoca el propio
        // cart:refresh (que ya programa su refresco más arriba). Re-leer /cart.js
        // aquí cuenta como actividad y alarga el overlay en bucle.
        if (!(window.__cartSettle && window.__cartSettle.isBusy())) {
          scheduleRefresh(120);
          scheduleRefresh(450);
        }
        return result;
      };
      window.WSAIO.__gifttiersUiWrapped = true;
    }

    window.GiftTiersQtyDiscount = window.GiftTiersQtyDiscount || {};
    window.GiftTiersQtyDiscount.refresh = refresh;
    window.GiftTiersQtyDiscount.scheduleRefresh = scheduleRefresh;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
